

























import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import { IFormatParameter, FormatParameter } from '@models';
import CampaignParametersFormTypeBase from '../CampaignParametersFormTypeBase/CampaignParametersFormTypeBase';


@Component
export default class CampaignParametersChoice extends CampaignParametersFormTypeBase {
  name = 'campaign-parameters-text';

  @Prop({
    type: Object as () => IFormatParameter,
    default: () => null
  })
  formatParameter: IFormatParameter;
  isDeleteAvailable: boolean = false;

  formatDefaults: {
    defaultValue: string,
    values: Array<string>,
  };

  onChoiceClear(event: any) {
    this.str = this.formatDefaults?.defaultValue;
  }

  get items() {
    return JSON.parse(this.formatParameter.value)?.values;
  }

  get str() {
    return this.local.value;
  }

  set str(str: string) {
    this.update(v => {
      v.file = null;
      v.value = str;
    });

    this.setDeleteAvailableProp(str);
  }

  // When we create a new campaign we have a json structure but when we update the choice in the editor we give it the value and not the json.
  setDeleteAvailableProp(value: string) {
    if (value && value.length > 0) {
      try {
        var jsonString = JSON.parse(this.str);
        if (jsonString) {
          this.isDeleteAvailable = this.formatDefaults?.defaultValue && this.formatDefaults?.defaultValue != jsonString.defaultValue;
        }
      } catch {
        if (this.formatDefaults?.values.indexOf(value) != -1) {
          this.isDeleteAvailable = this.formatDefaults.defaultValue && this.formatDefaults.defaultValue != value;
        }
      }
    } else {
      this.isDeleteAvailable = this.formatDefaults?.defaultValue && this.formatDefaults?.defaultValue.length > 0;
    }
  }

  created() {
    // Taking default value from fromat parameter, if the campaign has not already got one.
    try {
      this.formatDefaults = JSON.parse(this.formatParameter.value);
      if (this.formatDefaults?.defaultValue && (this.formatParameter.value === this.local.value)) {
        this.str = this.formatDefaults.defaultValue;
      }

      this.setDeleteAvailableProp(this.str);
    }
    catch (ex) {
      console.error("Could not parse choice field");
    }
  }

}
